// Personele Alacak Ekle / Personelden Tahsilat Yap penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'personnel.receivable';

export const personnelReceivableGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Personele alacak / tahsilat nasıl eklenir?'),
  intro: t(`${G}.intro`, 'Şirketin personele borçlandığı tutarı (alacak) veya personelden aldığınız parayı (tahsilat) kaydedersiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Personele Alacak Ekle / Personelden Tahsilat Yap'),
    body: t(`${G}.regions.body`, 'Yöntem, kasa/banka, tutar ve tarih'),
    footer: t(`${G}.regions.footer`, 'Alacağı / Tahsilatı Kaydet'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Hangi pencere açıldı?'),
      text: t(`${G}.s1.text`, '⋮ menüsündeki "Alacak Ekle" pencereyi "Personele Alacak Ekle" olarak, "Tahsilat Ekle" ise "Personelden Tahsilat Yap" olarak açar. Alacak, personelin şirketten alacağını; tahsilat, personelden alınan parayı kaydeder. İkisi de personelin Güncel Bakiyesini tutar kadar azaltır.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Yöntemi seçin'),
      text: t(`${G}.s2.text`, '"İşlem Türü" / "Tahsilat Yöntemi" alanında Tahakkuk, Nakit veya Banka seçin. Alacak Ekle Tahakkuk ile, Tahsilat Ekle Nakit ile açılır.'),
      tips: [
        t(`${G}.s2.tip1`, 'Tahakkuk: para hareketi olmaz, yalnız personel defterine kayıt yazılır.'),
        t(`${G}.s2.tip2`, 'Nakit: "Kasa Seçimi"nden paranın gireceği kasayı seçin. Banka: "Banka Hesabı Seçimi"nden hesabı (alt hesaplar dahil) seçin.'),
        t(`${G}.s2.tip3`, 'Listelerde yalnız Türk Lirası (₺) kasa ve banka hesapları, yanlarında bakiyeleriyle görünür; yoksa "Uygun kasa yok" yazar. Şube yöneticisi yalnız kendi şubesinin hesaplarını görür.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Tutar ve açıklama'),
      text: t(`${G}.s3.text`, '"Alacak Tutarı" / "Tahsilat Tutarı" zorunludur ve sıfırdan büyük olmalıdır. Açıklama isteğe bağlıdır; defterde ve kasa/banka hareketinde görünür.'),
      tips: [
        t(`${G}.s3.tip1`, '"Proje (opsiyonel)" ile kaydı bir projeye bağlayabilirsiniz; kasa/banka hareketine de aynı proje yazılır. Şube yöneticisinde bu alan görünmez.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Geçmiş tarihli işlem'),
      text: t(`${G}.s4.text`, '"Geçmiş tarihli işlem yap" kutusunu işaretlerseniz "İşlem Tarihi" alanı açılır; ileri bir tarih seçilemez. Kayıt ve oluşan kasa/banka hareketi tamamen seçtiğiniz tarihe yazılır. İşaretlemezseniz bugünün tarihi kullanılır.'),
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Kaydedin ve etkisi'),
      text: t(`${G}.s5.text`, '"Alacağı Kaydet" / "Tahsilatı Kaydet" kasa veya banka seçilmeden açılmaz. Nakit/Banka seçiliyse tutar seçilen kasaya/banka hesabına giriş olarak eklenir ve o hesabın bakiyesi artar; personel defterine kayıt yazılır ve Güncel Bakiye azalır. Personel kaydı ile kasa/banka hareketi birlikte kaydedilir; biri başarısız olursa hiçbiri kaydedilmez.'),
      tips: [
        t(`${G}.s5.tip1`, 'Yanlış kaydı Personel Hareketleri tablosundaki çöp kutusuyla silebilirsiniz; bağlı kasa/banka hareketi de silinir ve bakiye geri alınır.'),
      ],
    },
  ],
});
